// src/components/HerinneringenVoorkeur.js
//
// Schakelaar op de profielpagina: wel of geen herinneringsmails ontvangen.
// Staat los van de nieuwsbrief (Laposta).
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

function HerinneringenVoorkeur() {
  const [ontvangen, setOntvangen] = useState(null);
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState('');

  useEffect(() => {
    const jwt = localStorage.getItem('jwt');
    if (!jwt) return;
    axios
      .get(`${STRAPI_URL}/api/herinneringen/voorkeur`, { headers: { Authorization: `Bearer ${jwt}` } })
      .then((res) => setOntvangen(Boolean(res.data?.ontvangen)))
      .catch((error) => {
        console.error('Voorkeur herinneringen ophalen mislukt:', error);
        setMelding('Je voorkeur laden lukte niet.');
      });
  }, []);

  const wijzig = async (nieuweWaarde) => {
    const jwt = localStorage.getItem('jwt');
    if (!jwt) return;
    setBezig(true);
    setMelding('');
    try {
      await axios.put(
        `${STRAPI_URL}/api/herinneringen/voorkeur`,
        { ontvangen: nieuweWaarde },
        { headers: { Authorization: `Bearer ${jwt}` } }
      );
      setOntvangen(nieuweWaarde);
      setMelding(nieuweWaarde ? 'Je ontvangt weer herinneringen.' : 'Je ontvangt geen herinneringen meer.');
    } catch (error) {
      console.error('Voorkeur herinneringen opslaan mislukt:', error);
      setMelding('Opslaan lukte niet. Probeer het later opnieuw.');
    } finally {
      setBezig(false);
    }
  };

  return (
    <section className="profile-details-section" style={{ marginTop: '1.5rem' }}>
      <h3>Herinneringen per e-mail</h3>
      <p style={{ marginTop: 0 }}>
        Ben je een tijd niet op Doorloopjes geweest? Dan sturen we je hooguit één mail met doorloopjes die bij je passen. Dit staat los van de nieuwsbrief.
      </p>
      <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <input
          id="herinneringenOntvangen"
          type="checkbox"
          checked={ontvangen === true}
          disabled={ontvangen === null || bezig}
          onChange={(e) => wijzig(e.target.checked)}
          style={{ width: 'auto' }}
        />
        <label htmlFor="herinneringenOntvangen" style={{ marginBottom: 0 }}>
          Herinneringsmails ontvangen
        </label>
      </div>
      {melding && <p className="profile-message">{melding}</p>}
    </section>
  );
}

export default HerinneringenVoorkeur;
